import { render, staticRenderFns } from "./dataTable.vue?vue&type=template&id=3b3fd06a&scoped=true"
import script from "./dataTable.vue?vue&type=script&lang=js"
export * from "./dataTable.vue?vue&type=script&lang=js"
import style0 from "./dataTable.vue?vue&type=style&index=0&id=3b3fd06a&prod&lang=scss&scoped=true"
import style1 from "./dataTable.vue?vue&type=style&index=1&id=3b3fd06a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3fd06a",
  null
  
)

export default component.exports